import {
  ClaimFormsApi,
  ClaimFormResponse,
  ClaimFormGeoDataResponse,
  GetClaimFormByIdRequest,
  UpdateClaimFormByIdRequest,
  GetClaimFormSchemaRequest,
  GetClaimFormGeoDataRequest,
  SearchClaimFormsRequest,
  PageClaimFormSearchResult,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const searchClaimForms = async (
  query: string,
  resultStart: number,
  resultEnd: number,
  startDate?: string,
  endDate?: string,
  linkStatus?: string,
): Promise<PageClaimFormSearchResult> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  const request: SearchClaimFormsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    query,
    resultStart,
    resultEnd,
    startDate,
    endDate,
    linkStatus,
  }

  return await api.searchClaimForms(request)
}

const linkClaimForm = async (
  claimFormId: string,
  claimReservationId: string,
): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  return await api.linkClaimFormToReservation({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
    claimReservationId,
  })
}

const relinkClaimForm = async (
  claimFormId: string,
  claimReservationId: string,
): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  return await api.relinkClaimFormToReservation({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
    claimReservationId,
  })
}

const unlinkClaimForm = async (claimFormId: string, claimReservationId: string): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  await api.unlinkClaimFormFromReservation({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
    claimReservationId,
  })
}

const getClaimFormById = async (claimFormId: string): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  const request: GetClaimFormByIdRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
  }

  return await api.getClaimFormById(request)
}

const markClaimFormReceived = async (claimFormId: string): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  return await api.markClaimFormReceived({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
  })
}

const markClaimFormAuthorized = async (claimFormId: string): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  return await api.markClaimFormAuthorized({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
  })
}

const updateClaimFormById = async (
  claimFormId: string,
  formData: Record<string, unknown>,
): Promise<ClaimFormResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  const request: UpdateClaimFormByIdRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    claimFormId,
    requestBody: formData,
  }

  return await api.updateClaimFormById(request)
}

const getClaimFormSchema = async (): Promise<Record<string, unknown>> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  const request: GetClaimFormSchemaRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.getClaimFormSchema(request)
}

const getClaimFormGeoData = async (): Promise<ClaimFormGeoDataResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(ClaimFormsApi)
  const request: GetClaimFormGeoDataRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.getClaimFormGeoData(request)
}

export const ClaimFormsServiceAPI = {
  searchClaimForms,
  linkClaimForm,
  relinkClaimForm,
  unlinkClaimForm,
  getClaimFormById,
  markClaimFormReceived,
  markClaimFormAuthorized,
  updateClaimFormById,
  getClaimFormSchema,
  getClaimFormGeoData,
}
